'use client'

import type { ReactNode } from 'react'
import { createContext, useContext, useState } from 'react'

type LandingScreen = 'splash' | 'language'

interface NavigationContextType {
  view: 'landing' | 'xr' | 'credits'
  landingScreen: LandingScreen
  setView: (view: 'landing' | 'xr' | 'credits') => void
  setLandingScreen: (screen: LandingScreen) => void
  goToLanguageSelector: () => void
  navigateToCredits: () => void
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined)

export function NavigationProvider({ children }: { children: ReactNode }) {
  const [view, setView] = useState<'landing' | 'xr' | 'credits'>('landing')
  const [landingScreen, setLandingScreen] = useState<LandingScreen>('splash')

  const goToLanguageSelector = () => {
    console.log('Navigating to language selector', 'navigation')
    setView('landing')
    setLandingScreen('language')
  }

  const navigateToCredits = () => {
    console.log('Navigating to credits', 'navigation')
    setView('credits')
  }

  const value = {
    view,
    landingScreen,
    setView,
    setLandingScreen,
    goToLanguageSelector,
    navigateToCredits,
  }

  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>
}

export function useNavigation() {
  const context = useContext(NavigationContext)
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider')
  }
  return context
}
